export default function appendForm(channel, html) {
  $('#portal-name').css('color', '#838FA4').text(channel);

  $('#ownAccountModal').trigger('dom-update', {
    html,
  });
}
